export default __webpack_public_path__ + "static/media/avatar_lion10.9a917fd7.mp3";